import { Button, Icon } from '@octano/global-ui';
import { FunctionComponent } from 'react';

interface TeacherRowProps {
  children: React.ReactNode;
  isOnline: boolean;
  isPresential: boolean;
  showOnline?: boolean;
  showPresential?: boolean;
  disabled?: boolean;
  onToggleOnline?: () => void;
  onTogglePresential?: () => void;
  onDelete?: () => void;
}

export const TeacherRow: FunctionComponent<TeacherRowProps> = ({
  children,
  isOnline,
  isPresential,
  showOnline = true,
  showPresential = true,
  disabled = false,
  onToggleOnline,
  onTogglePresential,
  onDelete,
}) => {
  return (
    <div className="d-flex align-items-center" style={{ gap: 12 }}>
      <div className="flex-grow-1">{children}</div>
      {/* Botón de modalidad */}
      <div className="d-flex gap-3">
        {showPresential && (
          <Button
            text="P"
            style={{
              width: 50,
              height: 38,
              backgroundColor: isPresential ? '#CEF0DA' : undefined,
              marginBottom: '1rem',
            }}
            outlined
            disabled={disabled || !onTogglePresential}
            onClick={onTogglePresential}
          />
        )}
        {showOnline && (
          <Button
            text="O"
            style={{
              width: 50,
              height: 38,
              backgroundColor: isOnline ? '#CEF0DA' : undefined,
              marginBottom: '1rem',
            }}
            outlined
            disabled={disabled || !onToggleOnline}
            onClick={onToggleOnline}
          />
        )}
      </div>
      {/* Botón de eliminar */}
      {onDelete && (
        <button
          type="button"
          className="btn d-flex align-items-center justify-content-center"
          style={{
            width: 40,
            height: 40,
          }}
          disabled={disabled}
          onClick={onDelete}
        >
          <Icon name="trash" color={disabled ? 'disabled' : 'primary'} />
        </button>
      )}
    </div>
  );
};
